var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      style: { zIndex: "601", padding: "0 50px" },
      attrs: { width: "600" },
      on: { "click:outside": _vm.hideDialog },
      model: {
        value: _vm.conversationDialog,
        callback: function ($$v) {
          _vm.conversationDialog = $$v
        },
        expression: "conversationDialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            {
              staticClass: "d-block",
              attrs: { color: "grey lighten-4", dense: "", flat: "" },
            },
            [
              _c("v-toolbar-title", { staticClass: "fw-600" }, [
                _vm._v(_vm._s(_vm.$t("any_query_about_this_product"))),
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "ms-auto",
                  attrs: { icon: "", fab: "", small: "" },
                  on: { click: _vm.hideDialog },
                },
                [_c("i", { staticClass: "las la-times fs-24" })]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-card-text", { staticClass: "pa-4 text-dark" }, [
            _c(
              "div",
              { staticClass: "white pa-5 rounded" },
              [
                _c(
                  "v-form",
                  {
                    attrs: {
                      "lazy-validation": "",
                      autocomplete: "chrome-off",
                    },
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.addNewConversation()
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "mb-3" },
                      [
                        _c("div", { staticClass: "mb-1 fs-13 fw-500" }, [
                          _vm._v(_vm._s(_vm.$t("title"))),
                        ]),
                        _vm._v(" "),
                        _c("v-text-field", {
                          attrs: {
                            placeholder: _vm.$t("title"),
                            "error-messages": _vm.titleErrors,
                            "hide-details": "auto",
                            type: "text",
                            required: "",
                            outlined: "",
                          },
                          model: {
                            value: _vm.form.title,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "title", $$v)
                            },
                            expression: "form.title",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mb-3" },
                      [
                        _c("div", { staticClass: "mb-1 fs-13 fw-500" }, [
                          _vm._v(_vm._s(_vm.$t("message"))),
                        ]),
                        _vm._v(" "),
                        _c("v-textarea", {
                          attrs: {
                            placeholder: _vm.$t("message"),
                            "error-messages": _vm.messageErrors,
                            "hide-details": "auto",
                            rows: "4",
                            required: "",
                            outlined: "",
                          },
                          model: {
                            value: _vm.form.message,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "message", $$v)
                            },
                            expression: "form.message",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "text-right mt-4" },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              elevation: "0",
                              type: "submit",
                              color: "primary",
                              loading: _vm.sending,
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("send")) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }